export const BITMAP_FONT = 'PaperHand';
